export default function withDisabledNewlines(editor) {
  // eslint-disable-next-line no-param-reassign
  editor.insertBreak = () => {
    // do nothing
  };

  return editor;
}
